// seo-schema/sitemap-data.ts
//
// The canonical sitemap keep-list (spec §4.3: keep 19, drop 52) and the XML
// builder. lastmod is deliberately omitted — the working agreement bans faked
// dates and per-page change dates aren't tracked yet.
import { LOCALES, buildLanguageAlternates } from "./hreflang-alternates";

// Locale-less paths; "" = the locale landing (/en, /my-mm).
export const SITEMAP_PATHS: string[] = [
  "",
  "/flight",
  "/bus", // coexistence: drop once v5 owns bus URLs + its own sitemap (ADR-A19)
  "/hotel",
  "/hotel-long-stay",
  "/balloon",
  "/car-rental",
  "/tour-packages",
  "/travel-services/visa-service",
  "/travel-services/vip-service",
  "/insurance",
  "/insurance/premium-policy",
  "/promotion",
  "/about-us",
  "/contact-us",
  "/team",
  "/privacy-policy",
  "/mobileapp/download",
  "/verify-ticket",
];

// Dropped from the old 71-URL sitemap (Phase 2 also noindexes them): all
// in-app/in-web/auth URLs, email-verify, just-email-verify, forgot-password,
// create-password, show-message, redirect-intl-hotel, bus/transaction-fail,
// privacy-policy-boca.

export function buildSitemapXml(siteUrl: string): string {
  const site = siteUrl.replace(/\/$/, "");
  const urls: string[] = [];
  for (const path of SITEMAP_PATHS) {
    const alternates = buildLanguageAlternates(site, path);
    const alternateLinks = Object.entries(alternates)
      .map(
        ([hreflang, href]) =>
          `    <xhtml:link rel="alternate" hreflang="${hreflang}" href="${href}"/>`,
      )
      .join("\n");
    for (const locale of LOCALES) {
      urls.push(
        [`  <url>`, `    <loc>${site}/${locale}${path}</loc>`, alternateLinks, `  </url>`].join("\n"),
      );
    }
  }
  return [
    `<?xml version="1.0" encoding="UTF-8"?>`,
    `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xhtml="http://www.w3.org/1999/xhtml">`,
    ...urls,
    `</urlset>`,
    ``,
  ].join("\n");
}
